import React from 'react';
import 'react-spring-bottom-sheet/dist/style.css'
import styled from 'styled-components';
import {Header, Title} from './sheet';
import {Button} from "@chakra-ui/react";

const ProfilePictureSheet = styled(({className, onClose, onContinue}) => {

    return (
        <div className={className}>

            <Header>
                <Title>Set a profile picture</Title>
            </Header>

            <p>Consider setting a profile picture to show next to your posts and comments.</p>

            <Button variant={"blue"} width={"100%"} mt={8} onClick={onContinue}>Set profile picture</Button>
            <Button variant={"grey"} width={"100%"} mt={2} onClick={onClose}>Not now</Button>

        </div>
    );
})``;

export default ProfilePictureSheet;
